import React from 'react'
import { EquifaxReportContainer } from 'containers/Integrations/Reports/EquifaxReportContainer'

export const EquifaxReportPage = () => <EquifaxReportContainer />
